const init = () => {
    const chevronTop = document.querySelector('.chevronUp').classList;
    let scrollToTop = () => {
        let y = window.scrollY;
        y > 600 ? chevronTop.add('active') : chevronTop.remove('active');
    };

    window.addEventListener("scroll", scrollToTop);
}

function ready(init) {
    if (document.readyState != 'loading') {
        init();
    } else {
        document.addEventListener('DOMContentLoaded', init);
    }
}

ready(init);